import { Fragment } from 'react';
import type { ReactNode } from 'react';

import Stack from '@mui/material/Stack';

import { MessageList } from './MessageList';

export interface ActionableMessage {
  readonly message: string;
  // Labelled to be understood away from its message: the actions are gathered under the list.
  readonly action?: ReactNode;
}

interface Props {
  readonly items: readonly ActionableMessage[];
}

// The messages of an alert, their actions side by side under the list.
export const ActionableMessages = ({ items }: Readonly<Props>) => {
  const actions = items.filter(({ action }) => !!action);

  return (
    <>
      <MessageList messages={items.map(({ message }) => message)} />
      {!!actions.length && (
        <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1, mt: 1 }}>
          {actions.map(({ action, message }) => (
            <Fragment key={message}>{action}</Fragment>
          ))}
        </Stack>
      )}
    </>
  );
};
